import { actionTypes } from '../types/actionTypes'
import { ReducerPickingReport } from '../types/reducerTypes'
import { PickingItemProps } from '../screens/PickingStatesSquare/interfaces'
import { TypeBtn } from '../screens/PickingReportSearch/types/typeBtn'

const initialSelectPicking: PickingItemProps = {
  id: 0,
  qty: 0,
  title: '',
  height: '40%'
}

export const initialState: ReducerPickingReport = {
  isShowRoutes: false,
  selectPickingState: initialSelectPicking,
  selectedZone: 0,
  btnType: TypeBtn.CurrentDate,
  filteredDate: '',
  pickingItems: [],
  cardsItems: [],
  snackbar: {
    message: '',
    open: false,
    status: 'error'
  },
  pickingDetailItems: [],
  loading: false
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const pickingReportReducer = (
  state: ReducerPickingReport,
  action: actionTypes
) => {
  switch (action.type) {
    case 'setIsShowRoutes':
      return {
        ...state,
        isShowRoutes: action.payload
      }
    case 'setSelectPickingState':
      return {
        ...state,
        selectPickingState: action.payload
      }
    case 'setSelectedZone':
      return {
        ...state,
        selectedZone: action.payload
      }
    case 'setBtnType':
      return {
        ...state,
        btnType: action.payload
      }
    case 'setFilteredDate':
      return {
        ...state,
        filteredDate: action.payload
      }
    case 'setPickingItems':
      return {
        ...state,
        pickingItems: action.payload
      }
    case 'setCardsItems':
      return {
        ...state,
        cardsItems: action.payload
      }
    case 'setSnackbar':
      return {
        ...state,
        snackbar: action.payload
      }
    case 'setPickingDetailItems':
      return {
        ...state,
        pickingDetailItems: action.payload
      }

    case 'setLoading':
      return {
        ...state,
        loading: action.payload
      }

    default:
      return state
  }
}
